import { Typography, Button, Grid } from '@mui/material';
import AddTwoToneIcon from '@mui/icons-material/AddTwoTone';
import { useNavigate } from 'react-router';



function GotraPageheader() {
  const navigate = useNavigate();

  const handleGotraPage = () => {
    navigate('/gotra/add');
  } 
  return (
    <Grid container justifyContent="space-between" alignItems="center">
      <Grid item>
        <Typography variant="h3" component="h3" gutterBottom>
          Gotra
        </Typography>

      </Grid>
      <Grid item>
        <Button
          sx={{ mt: { xs: 2, md: 0 } }}
          variant="contained"
          onClick={handleGotraPage}
          startIcon={<AddTwoToneIcon fontSize="small" />}
        >
          Add Gotra
        </Button>
      </Grid>
    </Grid>
  );
}

export default GotraPageheader;
